import { HTTPAidaBaseService } from "../../../adapters/http";
import { getTenantFromToken } from "../../../config/helpers/common_helper";

export const GET_TEMPLATES = async () => {
    try {
        return await HTTPAidaBaseService.get(
            `/template/tenant/${getTenantFromToken()}`
        );
    } catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                code: err.response.data?.code,
                message: err.response.data?.message || err.message,
                details: err.response.data?.details || null
            };
        }
        throw new Error(err);
    }
};

export const GET_TEMPLATE = async (templateCode) => {
    try {
        return await HTTPAidaBaseService.get(
            `/template/tenant/${getTenantFromToken()}/code/${templateCode}`
        );
    } catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                code: err.response.data?.code,
                message: err.response.data?.message || err.message,
                details: err.response.data?.details || null
            };
        }
        throw new Error(err);
    }
};

export const DELETE_TEMPLATE = async (templateCode) => {
    try {
        return await HTTPAidaBaseService.delete(
            `/template/tenant/${getTenantFromToken()}/code/${templateCode}`
        );
    } catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                code: err.response.data?.code,
                message: err.response.data?.message || err.message,
                details: err.response.data?.details || null
            };
        }
        throw new Error(err);
    }
};

// Min length of the additional instructions is 20
// Max length of the additional instructions is 1000
export const ADJUST_TEMPLATE = async (templateCode, instructions) => {
    try {
        return await HTTPAidaBaseService.put(
            `/template/tenant/${getTenantFromToken()}/code/${templateCode}/instruction`,
            { instructions: instructions }
        );
    } catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                code: err.response.data?.code,
                message: err.response.data?.message || err.message,
                details: err.response.data?.details || null
            };
        }
        throw new Error(err);
    }
};

// Min length of the template name is 3
// Max length of the template name is 100
export const UPDATE_TEMPLATE = async (templateCode, template) => {
    try {
        const updatedTemplate = {
            ...template,
            // ...(template.hasOwnProperty("fhirQuestionnaireVersion") && {
            //     fhirQuestionnaireVersion: fhirQuestionnaireVersion
            // })
        };
        return await HTTPAidaBaseService.put(
            `/template/tenant/${getTenantFromToken()}/code/${templateCode}`,
            updatedTemplate
        );
    } catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                code: err.response.data?.code,
                message: err.response.data?.message || err.message,
                details: err.response.data?.details || null
            };
        }
        throw new Error(err);
    }
};


export const CREATE_TEMPLATE = async (payload) => {
    try {
        return await HTTPAidaBaseService.post(
            `/template/tenant/${getTenantFromToken()}`,
            payload,
        );
    } catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                code: err.response.data?.code,
                message: err.response.data?.message || err.message,
                details: err.response.data?.details || null
            };
        }
        throw new Error(err);
    }
};
